var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-page-title',{attrs:{"heading":_vm.$t('core.customer_area_setting_page_heading'),"subheading":_vm.$t('core.customer_area_setting_page_subheading')}}),_c('b-card',[_c('bpc-customer-area-setting-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }